
import { Hero } from "@/components/landing/Hero";
import { ProblemSolution } from "@/components/landing/ProblemSolution";
import { MarketStats } from "@/components/landing/MarketStats";
import { PlatformShowcase } from "@/components/landing/PlatformShowcase";
import { ComparisonTable } from "@/components/landing/ComparisonTable";
import { QuickStartGuide } from "@/components/landing/QuickStartGuide";
import PageLayout from "@/components/layout/PageLayout";

const Index = () => {
  return (
    <PageLayout>
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-primary text-white px-4 py-2 rounded-md z-50">
        Skip to content
      </a>
      
      <div id="main-content" className="space-y-4 pb-4">
        <Hero />
        
        <ProblemSolution />
        
        <ComparisonTable />
        
        <QuickStartGuide />
        
        <MarketStats />
        
        <PlatformShowcase />
      </div>
    </PageLayout>
  );
};

export default Index;
